import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { CustomSnackbarComponent } from './custom-snackbar.component';

@Injectable({ providedIn: 'root' })
export class SnackbarService {
  constructor(private snackBar: MatSnackBar) {}

  show(message: string, action: string = 'Close', duration: number = 3000) {
    this.snackBar.open(message, action, {
      duration,
      verticalPosition: 'top',
      horizontalPosition: 'right',
    });
  }
  
  showCustom(data: { type: 'success' | 'error' | 'warning', title: string, message: string, linkText?: string }) {
    this.snackBar.openFromComponent(CustomSnackbarComponent, {
      data,
      duration: 6000,
      panelClass: ['custom-snackbar-panel'],
      horizontalPosition: 'right',
      verticalPosition: 'top',
    });
  }
}
